/** Minimum length; keep in sync with backend `PASSWORD_MIN_LEN` (user schema). */
export const PASSWORD_MIN_LENGTH = 10;

/**
 * Password rules aligned with backend `validate_password_policy` (UserCreate / change-password).
 */
export function validatePasswordPolicy(value: string, t: (key: string) => string): string | true {
  if (!value || value.length < PASSWORD_MIN_LENGTH) return t("validation_password_min_length");
  if (value.length > 128) return t("validation_password_max_length");
  if (!/[A-Z]/.test(value)) return t("validation_password_uppercase");
  if (!/[a-z]/.test(value)) return t("validation_password_lowercase");
  if (!/\d/.test(value)) return t("validation_password_number");
  return true;
}
